import { useCallback, useState } from "react";
import { signIn } from "next-auth/react";

const useMicrosoftSignIn = (successCb?: () => void) => {
  const [isMicrosoftLoading, setIsLoading] = useState(false);

  const onSignIn = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsLoading(true);

    try {
      await signIn("azure-ad");
      successCb && successCb();
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { onSignIn, isMicrosoftLoading };
};

export default useMicrosoftSignIn;
